import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.genericGridContentOnlySection.scss';

const GenericGridContentOnlySection = ({ data }) => {
    const linkCheck = data.genericGridContentOnlySectionCta === "textlink" ? "l-textLink" : "l-button";
    return (
        <div className="cp-genericGridContentOnlySection" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-genericGridContentOnlySection__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                {data.selectLayout === 'layout2' ?
                    <>
                        <div className={`cp-genericGridContentOnlySection__gridSection l--flex l-${data.selectLayout}`} style={{ backgroundColor: `${data.genericGridContentOnlySectionGridBackgroundColor}` }}>
                            {data.genericGridContentOnlySectionGridRepeater &&
                                <>
                                    <div className="cp-genericGridContentOnlySection__gridSection-section">
                                        {data.genericGridContentOnlySectionTitle &&
                                            <h2><span>{data.genericGridContentOnlySectionTitle}</span></h2>
                                        }
                                        {data.genericGridContentOnlySectionTeaser &&
                                            <p dangerouslySetInnerHTML={{ __html: data.genericGridContentOnlySectionTeaser }} />
                                        }
                                    </div>
                                    {data.genericGridContentOnlySectionGridRepeater.map((contentOnlyItem, index) => (
                                        <div className="cp-genericGridContentOnlySection__gridSection-section" key={index}>
                                            {contentOnlyItem.icon &&
                                                <GatsbyImage image={getImage(contentOnlyItem.icon.gatsbyImage)} alt={contentOnlyItem.icon.altText} />
                                            }
                                            {contentOnlyItem.title &&
                                                <h4><span>{contentOnlyItem.title}</span></h4>
                                            }
                                            {contentOnlyItem.teaser &&
                                                <p dangerouslySetInnerHTML={{ __html: contentOnlyItem.teaser }} />
                                            }
                                        </div>
                                    ))}
                                </>
                            }
                        </div>
                    </>
                    :
                    <>
                        {data.genericGridContentOnlySectionSubTitle &&
                            <h3>{data.genericGridContentOnlySectionSubTitle}</h3>
                        }
                        <div className="cp-genericGridContentOnlySection__headerContent l--flex">
                            <h2>{data.genericGridContentOnlySectionTitle}</h2>
                            {data.genericGridContentOnlySectionLink &&
                                <a className={linkCheck} href={data.genericGridContentOnlySectionLink.url} target={data.genericGridContentOnlySectionLink.target}>{data.genericGridContentOnlySectionLink.title}</a>
                            }
                        </div>
                        <div className="cp-genericGridContentOnlySection__gridSection l--flex" style={{ backgroundColor: `${data.genericGridContentOnlySectionGridBackgroundColor}` }}>
                            {data.genericGridContentOnlySectionGridRepeater &&
                                <>
                                    {data.genericGridContentOnlySectionGridRepeater.map((contentOnlyItem, index) => (
                                        <div className="cp-genericGridContentOnlySection__gridSection-section" key={index}>
                                            {contentOnlyItem.icon &&
                                                <GatsbyImage image={getImage(contentOnlyItem.icon.gatsbyImage)} alt={contentOnlyItem.icon.altText} />
                                            }
                                            <h4><span>{contentOnlyItem.title}</span></h4>
                                            <p dangerouslySetInnerHTML={{ __html: contentOnlyItem.teaser }} />
                                        </div>
                                    ))}
                                </>
                            }
                        </div>
                    </>
                }
            </div>
        </div>
    );
}

export default GenericGridContentOnlySection;